<!-- <button (click)="throwTestError()">Test Sentry Error</button> -->
<div *ngIf="loaded===false" id="app-loader"
  class="app-loader vh-100 vw-100 d-flex justify-content-center align-items-center">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<router-outlet></router-outlet>
<div class="toast-list">
</div>

<div class="toast-container toastClone bottom-0 end-0 p-3">
  <div class="toast rounded-2 bg align-items-center text-white border-0" role="alert" aria-live="assertive"
    aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body">
        <div class="d-flex gap-3 align-items-center">
          <i class="icon bi fs-4" (click)="sharedService.copyText(toast.message)"></i>
          <div>
            <strong class="title">{{ toast.title }}</strong><br *ngIf="toast.title">
            <p class="mb-0 content">{{ toast.message }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal" id="confirmModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="confirm.title && confirm.title.length > 0">
        <h5 class="modal-title text-start">
          <i class="bi bi-exclamation-triangle me-2"></i>
          {{ confirm.title }}
        </h5>
      </div>
      <div class="modal-body">
        <div class="text-{{ confirm.type }}">
          <span>
            {{ confirm.message }}
          </span>
        </div>
        <div class="float-end mt-4">
          <button *ngIf="!confirm.skipCancel" type="button" class="btn btn-outline-secondary btn-sm me-3 fs-14"
            data-bs-dismiss="modal" (click)="onConfirm(false)">
            {{'btn_cancel' | translate}}
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm fs-14" data-bs-dismiss="modal"
            (click)="onConfirm(true)">
            {{'btn_confirm' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="alert" data-bs-keyboard="true" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="alert.title && alert.title.length > 0">
        <h5 class="modal-title text-start">
          <i class="fa-thin fa-bell-exclamation me-2"></i>
          {{ alert.title }}
        </h5>
      </div>
      <div class="modal-body">
        <div class="p-3">
          {{ alert.message }}
        </div>
      </div>
    </div>
  </div>
</div>